module.exports = __webpack_public_path__ + "img/point_bg.74106aa9.png";